import { inject, Injectable } from '@angular/core';
import { Functions, httpsCallableData } from '@angular/fire/functions';
import { Observable } from 'rxjs';

import { Feedback } from './feedback';

@Injectable({
  providedIn: 'root',
})
export class FeedbackSubmitService {
  private readonly functions = inject(Functions);

  submitFeedback(feedback: Feedback): Observable<void> {
    return httpsCallableData<Feedback, void>(this.functions, 'submitFeedback')(feedback);
  }
}
